export default "__VITE_ASSET__LoHCgyUT__"